import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeletedOrdersRoutingModule } from 'src/app/pages/deleted-orders/deleted-orders-rounting.module';
import { DeletedOrdersComponent } from './deleted-orders/deleted-orders.component';

import { SharedModule } from '@app/sharedModule/shared.module';
import { StoreModule } from '@ngrx/store';
import * as fromDeletedOrders from './store/reducers';
import { EffectsModule } from '@ngrx/effects';
import { DeletedOrdersEffects } from './store/effects';
import { RestoreOrderDialog } from '@app/pages/deleted-orders/dialogs/restore-order.dialog/restore-order.dialog';
import { StorybookModule } from '@storybook/storybook.module';

@NgModule({
  declarations: [DeletedOrdersComponent, RestoreOrderDialog],
  imports: [
    CommonModule,
    SharedModule,
    DeletedOrdersRoutingModule,
    StoreModule.forFeature(fromDeletedOrders.featureKey, fromDeletedOrders.reducers),
    EffectsModule.forFeature([DeletedOrdersEffects]),
    StorybookModule,
  ],
})
export class DeletedOrdersModule {}
